import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'SPI Linewalk',
    path: '/leadership-capabilities',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'spi-linewalk',
      allowedRoles: [...allowed.spi.roles],
    },
    component: () =>
      import(
        '@/modules/spi-linewalk/containers/spi-linewalk-root.container.vue'
      ),
    children: [
      {
        name: 'spi-reports',
        path: 'spi-reports',
        component: () =>
          import('@/modules/spi-linewalk/containers/reports-list.vue'),
      },
      {
        name: 'spi-linewalk-new-report',
        path: 'spi-linewalk',
        component: () =>
          import('@/modules/spi-linewalk/containers/basic-information.vue'),
      },
      {
        name: 'spi-linewalk-new-report-edit',
        path: 'spi-linewalk/:id',
        component: () =>
          import('@/modules/spi-linewalk/containers/basic-information.vue'),
      },
      {
        name: 'spi-deviations',
        path: 'spi-deviations/:id',
        component: () =>
          import('@/modules/spi-linewalk/containers/deviations.vue'),
      },
      {
        name: 'spi-report-summary',
        path: 'report-summary/:id',
        component: () =>
          import('@/modules/spi-linewalk/containers/report-summary.vue'),
      },
      {
        name: 'spi-summary',
        path: 'summary/:id',
        component: () =>
          import('@/modules/spi-linewalk/containers/summary.vue'),
      },
      {
        name: 'spi-module-settings',
        path: 'spi-reports/settings',
        meta: {
          allowedRoles: [...allowed.spi.settings],
        },
        component: () =>
          import(
            '@/modules/spi-linewalk/containers/spi-module-settings.container.vue'
          ),
      },
    ],
  },
]

export default index
